import Heading, { HeadingProps } from '@/components/Heading';
import cn from 'classnames';

export default function RendererHeading({ className, ...props }: HeadingProps) {
  return <Heading className={cn(`mt-12`, className)} {...props} />;
}
